import { render, staticRenderFns } from "./CaseCardItem.vue?vue&type=template&id=6b375272"
import script from "./CaseCardItem.vue?vue&type=script&lang=js"
export * from "./CaseCardItem.vue?vue&type=script&lang=js"
import style0 from "./CaseCardItem.vue?vue&type=style&index=0&id=6b375272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports